export class QueryStringParam {
    Key: string;
    Value: string;
}

export class GenericFilterModel {
    SkipRecords?: number;
    PageNo?: number;
    PageSize?: number;
    SortOrder: string;
    SortField: string;
    Filters: Array<QueryStringParam>;
}

export class SecurityQuestionAnswer {

    SecQuestionText1: string;
    SecQuestionCode1: string;
    SecAnswerText1: string;

    SecQuestionText2: string;
    SecQuestionCode2: string;
    SecAnswerText2: string;

    SecQuestionText3: string;
    SecQuestionCode3: string;
    SecAnswerText3: string;
}
